import * as React from 'react';
import './button.scss';

export const Button = (props) => {
	let { type, className } = props;
	if (type) {
		className = `${className} btn-${type}`;
	}
	return <button {...props} className={`btn ${className || ''}`}> {props.children}</button>;
};
export default Button;
